import React from "react";
import { Field } from "..";
import { Skeleton } from "@material-ui/lab";
import styles from "./loading-data-field.module.scss";

const LoadingDataField = ({ label, data, value, labelClassName, classDesc }) => {
  return (
    <Field label={label} horizontal labelClassName={labelClassName ?? styles.classLabel}>
      {data ? value ?? "--" : <Skeleton className={styles.skeletonSize} />}
    </Field>
  );
};

export default LoadingDataField;
